import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 15px;
  background: white;

  ${props =>
    props.isOverlay &&
    css`
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 10000;
      margin: 0;
      padding: 10px;
    `}

  &:fullscreen {
    padding: 10px;
  }

  &:-webkit-full-screen {
    width: 100%;
    height: 100%;
    padding: 10px;
  }
`;

export const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 10px;
  padding: 10px 0;

  a.btn,
  button.btn {
    margin: 0;
  }
`;

export const ViewerArea = styled.div`
  position: relative;
  width: 100%;
  height: 75vh;
  max-height: 800px;
  min-height: 480px;
  border: 1px solid #ddd;
  border-radius: 7px;
  overflow: hidden;
  background: white;

  @media (max-width: 767px) {
    height: 70vh;
    min-height: 0;
  }

  ${props =>
    props.isFullscreen &&
    css`
      flex: 1;
      height: auto;
      max-height: none;
      min-height: 0;

      @media (max-width: 767px) {
        height: auto;
      }
    `}

  iframe {
    display: block;
    width: 100%;
    height: 100%;
    border: 0;
  }
`;

export const Loading = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;

  img {
    max-height: 60%;
    max-width: 60%;
  }
`;

export const ErrorBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  min-height: 300px;
  margin-bottom: 15px;
  padding: 40px 20px;
  border: 1px solid #ddd;
  border-radius: 7px;
  background: white;
  text-align: center;

  p {
    margin: 0;
    font-size: 1.1em;
    font-weight: bold;
  }
`;
